module Client.Admin.EditUser.Tags.Create

open Client
open Shared
open System
open Elmish
open Illy.SafeStack
open Illy.SafeStack.Client
open Shared.Admin.Tags.Create

type Model = 
    {
        Name: Text.Model
        Saving: bool
    }

let toDTO (m: Model) = 
    {
        Name = Text.toString m.Name
    }

module Validations = 
    open Illy.SafeStack.Validation
    open Illy.SafeStack.CompositionalValidation
    open Shared.Admin.Tags.Create.Validations

    let resetValidations (model: Model) = 
        {model with 
            Name = Text.resetValidations model.Name
        }

    let dispatchValidations model = 
        let model = resetValidations model 
        function 
        | ValidationResult.Passed -> model 
        | ValidationResult.Warned _ -> failwith "Did not expect warnings"
        | ValidationResult.Failed (err, _) ->
            let errors = err |> List.map NameValidations.toString
            {model with 
                Name = Text.setValidations model.Name (concatOptional errors) None
            }

type Msg = 
    | ApiError of ApiError
    | SaveResult of FailureReason option
    | NameMsg of Text.Msg
    | CloseOverlay  
    | SaveClicked 

type Event = 
    | CloseOverlay 
    | ApiError of ApiError 
    | SaveSuccessful of notification: string 

module Initialisations =
    let initName value =
        Text.CustomSettings.defaultOptions()
        |> Text.init "Name" "Tag Name" (Some "Enter Tag Name") 255. true value

let init() = 
    {
        Name = Initialisations.initName None 
        Saving = false
    }, []

let update msg model = 
    match msg with 
    | Msg.ApiError err -> model, err |> ApiError |> SideEffect.Event 
    | Msg.CloseOverlay -> model, CloseOverlay |> SideEffect.Event 
    | NameMsg cMsg ->
        let m, c = Text.update cMsg model.Name
        {model with Name = m}, Cmd.map NameMsg c |> SideEffect.Cmd
    | SaveClicked -> 
        let dto = toDTO model 
        let vResult = Validations.validateDTO [] dto
        if Validation.isSuccessful false vResult then 
            {model with Saving = true},
            Api.secureCall<ICreateTagApi,_,_,_> SecuredRoute.Admin (fun api -> api.create) dto SaveResult Msg.ApiError
            |> SideEffect.Cmd
        else 
            Validations.dispatchValidations model vResult, SideEffect.none
    | SaveResult reason -> 
        match reason with 
        | None -> 
            model, "Tag was created successfully." |> Event.SaveSuccessful |> SideEffect.Event
        | Some (FailedValidations v) ->
            Validations.dispatchValidations {model with Saving = false} v, SideEffect.none

let view model dispatch = 
    jQueryUI.modal "Create Tag" 50 Msg.CloseOverlay dispatch (Some 800) [
        Text.text false model.Name (NameMsg >> dispatch)
        yield! UI.saveControls None false model.Saving SaveClicked Msg.CloseOverlay dispatch
    ]